import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Autocomplete,
  Box,
  Typography,
} from "@mui/material";
import { checkOper_or_admin } from "../utils/tool";

const sxTextField = {
  m: 0.5,
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: 13,
  },
  "& .MuiInputLabel-root": {
    fontSize: 13,
  },
};

export default function Addinginput(props) {
  const [init_data, set_init_data] = useState(props.init_data);
  const [value_adding, setValueAdding] = useState(null);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {checkOper_or_admin() ? (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          {props.init_data.hide ? (
            <Button
              size="small"
              variant="contained"
              color="success"
              sx={{
                borderRadius: "20px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: 13,
              }}
              onClick={() => {
                props.onShowClick(props.init_data._id);
              }}
            >
              Show
            </Button>
          ) : (
            <Button
              size="small"
              variant="outlined"
              color="error"
              sx={{
                borderRadius: "20px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: 13,
              }}
              onClick={() => {
                props.onHideClick(props.init_data._id);
              }}
            >
              Hide
            </Button>
          )}
        </Box>
      ) : null}

      <Typography
        sx={{ fontSize: 13, fontWeight: 600, color: "#555", mt: 0.5 }}
      >
        Label
      </Typography>
      <TextField
        sx={{ ...sxTextField, flex: 1 }}
        size="small"
        id="label"
        placeholder="Enter label"
        variant="outlined"
        value={init_data.label}
        onChange={(e) => set_init_data({ ...init_data, label: e.target.value })}
      />

      <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#555", mt: 1 }}>
        Activities
      </Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <TextField
          sx={{ ...sxTextField, flex: 4 }}
          size="small"
          id="activities"
          label="Activities (EN)"
          variant="outlined"
          multiline
          minRows={3}
          value={init_data.activities}
          onChange={(e) =>
            set_init_data({ ...init_data, activities: e.target.value })
          }
        />
        <TextField
          sx={{ ...sxTextField, flex: 4 }}
          size="small"
          id="activities_vi"
          label="Activities (VI) - Tax"
          variant="outlined"
          multiline
          minRows={3}
          value={init_data.activities_vi}
          onChange={(e) =>
            set_init_data({ ...init_data, activities_vi: e.target.value })
          }
        />
        <TextField
          sx={{ ...sxTextField, flex: 4 }}
          size="small"
          id="activities_en_tax"
          label="Activities (EN) - Tax"
          variant="outlined"
          multiline
          minRows={3}
          value={init_data.activities_en_tax || init_data.activities}
          onChange={(e) =>
            set_init_data({ ...init_data, activities_en_tax: e.target.value })
          }
        />
        <Autocomplete
          isOptionEqualToValue={(option, value) => option.id === value.id}
          disablePortal
          disableClearable
          size="small"
          id="combo-box-demo"
          options={props.accom}
          getOptionLabel={(option) => option.code}
          sx={{ width: 220, mt: 0.5 }}
          defaultValue={{ code: props.init_data.accomodation_code }}
          onChange={(e, value) => setValueAdding(value)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Accommodation code"
              value={params.code}
              sx={sxTextField}
            />
          )}
        />
      </Box>

      <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#555", mt: 1 }}>
        Detail
      </Typography>
      <TextField
        sx={{ ...sxTextField, flex: 3 }}
        size="small"
        id="activities_detail"
        label="Detail (EN)"
        variant="outlined"
        multiline
        minRows={4}
        value={init_data.detail}
        onChange={(e) =>
          set_init_data({ ...init_data, detail: e.target.value })
        }
      />
      <TextField
        sx={{ ...sxTextField, flex: 3 }}
        size="small"
        id="activities_detail_vi"
        label="Detail (VI)"
        variant="outlined"
        multiline
        minRows={4}
        value={init_data.detail_vi}
        onChange={(e) =>
          set_init_data({ ...init_data, detail_vi: e.target.value })
        }
      />

      <TextField
        sx={{ ...sxTextField, flex: 3 }}
        size="small"
        id="activities_detail_en_tax"
        label="Detail (EN) - Tax"
        variant="outlined"
        multiline
        minRows={4}
        value={init_data.detail_en_tax || init_data.detail}
        onChange={(e) =>
          set_init_data({ ...init_data, detail_en_tax: e.target.value })
        }
      />

      <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#555", mt: 1 }}>
        Logistics
      </Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <TextField
          sx={{ ...sxTextField, flex: 3 }}
          size="small"
          id="pickuptime"
          label="Pickup time"
          variant="outlined"
          multiline
          minRows={2}
          value={init_data.pickuptime}
          onChange={(e) =>
            set_init_data({ ...init_data, pickuptime: e.target.value })
          }
        />
        <TextField
          sx={{ ...sxTextField, flex: 3 }}
          size="small"
          id="transportation"
          label="Transportation"
          variant="outlined"
          value={init_data.transportation}
          onChange={(e) =>
            set_init_data({ ...init_data, transportation: e.target.value })
          }
        />
        <TextField
          sx={{ ...sxTextField, flex: 3 }}
          size="small"
          id="guide"
          label="Guide"
          variant="outlined"
          value={init_data.guide}
          onChange={(e) =>
            set_init_data({ ...init_data, guide: e.target.value })
          }
        />
      </Box>

      {checkOper_or_admin() ? (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
          <Button
            variant="contained"
            disableElevation
            sx={{
              borderRadius: "20px",
              textTransform: "none",
              fontWeight: 500,
              fontSize: 13,
              px: 4,
            }}
            onClick={() => {
              let data = init_data;
              if (value_adding != null) {
                data.accomodation_code = value_adding.code;
              }
              props.onSaveClick(props.init_data._id, data);
            }}
          >
            Save
          </Button>
        </Box>
      ) : null}
    </Box>
  );
}
